import React, { useEffect, useState } from "react";
import { useItemConfigContext } from "../../hooks/useContext/useItemConfigContext";
import { useAuthContext } from "../../hooks/useContext/useAuthContext";
import ErrorBox from "../Shared/ErrorBox";
import {
  Box,
  TextField,
  Button,
  Typography,
  FormControl,
  InputLabel,
  // IconButton,
  MenuItem,
  Select,
  CircularProgress,
  Input,
  FormHelperText,
} from "@mui/material";
import { styled } from "@mui/system";
import { useTheme } from "@mui/material/styles";
import ImageContainer from "../Shared/ImageContainerBox";
// import { Delete } from '@mui/icons-material';

const CenteredDiv = styled("div")({
  display: "flex",
  justifyContent: "center",
});

const InputContainer = styled(Input)({
  padding: "6px 12px",
  margin: ".8rem",
});

const ItemConfigForm = () => {
  const theme = useTheme();
  const { dispatch } = useItemConfigContext();
  const { user } = useAuthContext();
  const [itemName, setItemName] = useState("");
  const [itemPrice1, setItemPrice1] = useState("");
  const [itemPrice2, setItemPrice2] = useState("");
  const [itemIncludes, setItemIncludes] = useState("");
  let [itemAvailable, setItemAvailable] = useState("");
  const [itemType, setItemType] = useState("");
  const [itemSize, setItemSize] = useState("Jeden rozmiar");
  const [imageFile, setImageFile] = useState(null);
  const [itemPriceAmount, setItemPriceAmount] = useState(false);
  const itemTypeOptions = ["Jedzenie", "Napoje", "Napoje Alkoholowe"];
  const itemSizeOptions = ["Jeden rozmiar", "Małe i Duże"];
  const itemAvailableOptions = ["Nie", "Tak"];
  const [error, setError] = useState(null);
  const [emptyFields, setEmptyFields] = useState([]);
  const [loading, setLoading] = useState(false);
  const [itemPrice1Error, setItemPrice1Error] = useState(null);
  const [itemPrice2Error, setItemPrice2Error] = useState(null);
  const [expanded, setExpanded] = useState(false);
  let newItemDetails;

  const toggleForm = () => setExpanded(!expanded);

  //render large item price input field if item size is Małe i Duże
  useEffect(() => {
    if (itemSize === "Małe i Duże") {
      setItemPriceAmount(false);
    } else {
      setItemPriceAmount(true);
    }
  }, [itemSize]);


  //useEffect to check if itemPrice1 and itemPrice2 is a number
  useEffect(() => {
    if (isNaN(itemPrice1)) {
      setItemPrice1Error("Please enter a valid number");
      setEmptyFields((emptyFields) => [...emptyFields, "itemPrice1"]);
    } else {
      setItemPrice1Error(null);
      setEmptyFields((emptyFields) =>
        emptyFields.filter((field) => field !== "itemPrice1")
      );
    }
    if (isNaN(itemPrice2) && itemSize === "Małe i Duże") {
      setItemPrice2Error("Please enter a valid number");
      setEmptyFields((emptyFields) => [...emptyFields, "itemPrice2"]);
    } else {
      setItemPrice2Error(null);
      setEmptyFields((emptyFields) =>
        emptyFields.filter((field) => field !== "itemPrice2")
      );
    }
  }, [itemPrice1, itemPrice2, itemSize]);


//frontend error handling
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!user) {
      setError("You must be logged in");
      return;
    }
    let emptyFieldsClientSide = [];
    if (!itemName) {
      emptyFieldsClientSide.push("itemName");
      setError("Please set name");
    }
    if (!itemSize) {
      emptyFieldsClientSide.push("itemSize");
      setError("Please select item size");
    }
    if (!itemPrice1) {
      emptyFieldsClientSide.push("itemPrice1");
      setError("Please set price");
    }
    if (itemSize === "Małe i Duże" && !itemPrice2) {
      emptyFieldsClientSide.push("itemPrice2");
      setError("Please set large item price");
    }
    if (!itemType) {
      emptyFieldsClientSide.push("itemType");
      setError("Please select food, Napoje, albo Napoje Alkoholowe");
    }
    if (!itemAvailable) {
      emptyFieldsClientSide.push("itemAvailable");
      setError("Please select availability");
    }
    if (emptyFieldsClientSide.length > 0) {
      setEmptyFields(emptyFieldsClientSide);
      if (emptyFieldsClientSide.length > 1) {
        setError("Proszę wypełnić wszystkie pola");
      }
      return;
    }

    if (itemAvailable === "Tak") {
      itemAvailable = true;
    } else {    
      itemAvailable = false;
    }

    if (itemSize !== "Jeden rozmiar") {
      newItemDetails = [
        {itemPrice: parseFloat(itemPrice1), itemSize: "Małe"},
        {itemPrice: parseFloat(itemPrice2), itemSize: "Duże"}
      ];
    } else {
      newItemDetails = [
        {itemPrice: parseFloat(itemPrice1), itemSize: "Jeden rozmiar"}
      ];
    }
    setLoading(true);

    try{
      const data = new FormData();
      data.append('file', imageFile)
      data.append('itemName', itemName)
      data.append('itemType', itemType)
      data.append('itemDetails', JSON.stringify(newItemDetails))
      data.append('itemIncludes', itemIncludes)
      data.append('itemAvailable', itemAvailable)

      const response = await fetch(
        process.env.REACT_APP_SERVER_URL + "/api/itemconfigs",
        {
          method: "POST",
          body: data,
          headers: {
            Authorization: `Bearer ${user.token}`,
          },
      });
      const json = await response.json();
      setLoading(false);

      if (!response.ok) {
        setError(json.error);
        setEmptyFields(json.emptyFieldsBackEnd);
        console.log(json.error);
      }
      if (response.ok) {
        setImageFile(null);
        setItemName("");
        setItemPrice1("");
        setItemPrice2("");
        setItemIncludes("");
        setItemSize("");
        setItemType("");
        setItemAvailable("");
        setError(null);
        setEmptyFields([]);
        dispatch({ type: "CREATE_ITEMCONFIG", payload: json });
      }
    } catch (error) {
      console.error(error);
      setError("Wystąpił błąd, proszę spróbować ponownie");
    }
  };


  return (
    <Box
      component="form"
      sx={{
        "& > :not(style)": {
          m: 1,
          width: "100%",
        },
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        backgroundColor: "white",
        p: 2,
        borderRadius: "8px",
        boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
        transition: "all 0.3s ease",
        maxHeight: expanded ? "auto" : "200px",
        overflow: "hidden",
      }}
      noValidate
      autoComplete="off"
      onSubmit={handleSubmit}
    >
      <div style={{ display: "flex", justifyContent: "space-between", cursor: "pointer" }}>
        <Typography variant="h6" component="h3">
          Doday nowy Item
        </Typography>
      </div>

      {/* Button to expand the form if it is not expanded */}
      {!expanded && (
        <Button
          variant="contained"
          sx={{
            marginTop: "1rem",
            backgroundColor: theme.palette.primary.main,
            ":hover": { bgcolor: theme.palette.secondary.main },
          }}
          onClick={toggleForm}
        >
          Rozwiń Form
        </Button>
      )}

      {expanded && (
        <>
        {imageFile ? (
          <ImageContainer
            itemImage={imageFile ? URL.createObjectURL(imageFile) : null}
            itemName={itemName}
          />
        ) : null}
        {/* <Box display="flex" alignItems="center"> */}
        <InputContainer
          type="file"
          onChange={(event) => {
            const file = event.target.files[0];
            if (file) {
              setImageFile(file);
            }
          }}
        />
        {/* {imageFile && 
          <IconButton
            sx={{
              color: theme.palette.component.componentBackground,
              backgroundColor: theme.palette.component.componentBackground,
              ":hover": { bgcolor: theme.palette.common.offWhite },
            }}
            size="large"
            aria-label="Usuń"
            aria-haspopup="true"
            ariant="outlined"
            onClick={() => setImageFile(null)}
          >
          <Delete sx={{color: theme.palette.common.error}}/>
          </IconButton>
        }
        </Box> */}
        <TextField
          required={true}
          label="Nazwa Item"
          type="text"
          onChange={(e) => setItemName(e.target.value)}
          value={itemName}
          error={emptyFields && emptyFields.includes("itemName")}
          sx={{ marginTop: "0.5rem" }}
        />
        <FormControl required={true} fullWidth variant="outlined" margin="normal">
          <InputLabel id="itemSize">Rozmiar</InputLabel>
          <Select
            labelId="itemSize"
            id="itemSize"
            value={itemSize}
            onChange={(e) => setItemSize(e.target.value)}
            label="Rozmiar"
            error={emptyFields && emptyFields.includes("itemSize")}
          >
            <MenuItem value="">
              <em>Rozmiar?</em>
            </MenuItem>
            {itemSizeOptions.map((option) => (
              <MenuItem key={option} value={option}>
                {option}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
        <TextField
          fullWidth
          required={true}
          label={itemPriceAmount ? "Cena" : "Cena małego item"}
          autoComplete="Cena"
          type="currency"
          onChange={(e) => setItemPrice1(e.target.value)}
          value={itemPrice1}
          error={(emptyFields && emptyFields.includes("itemPrice1")) || Boolean(itemPrice1Error)}
          sx={{ marginTop: "0.5rem" }}
        />
        {itemPrice1Error && (
          <FormHelperText sx={{color: theme.palette.common.error}}>{itemPrice1Error}</FormHelperText>
        )}

        {!itemPriceAmount && (
        <TextField
          required={true}
          label="Cena Dużego Item"
          autoComplete="Cena Dużego Item"
          type="currency"
          onChange={(e) => setItemPrice2(e.target.value)}
          value={itemPrice2}
          error={(emptyFields && emptyFields.includes("itemPrice2")) || Boolean(itemPrice2Error)}
          sx={{ marginTop: "0.5rem" }}
        />
        )}
        {itemPrice2Error && (
          <FormHelperText sx={{color: theme.palette.common.error}}>{itemPrice2Error}</FormHelperText>
        )}
        <TextField
          required={false}
          name="itemIncludes"
          id="itemIncludes"
          label="Szczegóły"
          autoComplete="Szczegóły"
          rows={4}
          multiline
          onChange={(e) => setItemIncludes(e.target.value)}
          value={itemIncludes}
          error={emptyFields && emptyFields.includes("itemIncludes")}
          sx={{ marginTop: "0.5rem" }}
        />
        <FormControl required={true} fullWidth variant="outlined" margin="normal">
          <InputLabel id="itemType">Typ</InputLabel>
          <Select
            labelId="itemType"
            id="itemType"
            value={itemType}
            onChange={(e) => setItemType(e.target.value)}
            label="Typ"
            error={emptyFields && emptyFields.includes("itemType")}
          >
            <MenuItem value="">
              <em>Typ?</em>
            </MenuItem>
            {itemTypeOptions.map((option) => (
              <MenuItem key={option} value={option}>
                {option}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
        <FormControl required={false} fullWidth variant="outlined" margin="normal">
          <InputLabel id="itemAvailable">Dostępne?</InputLabel>
          <Select
            labelId="itemAvailable"
            id="itemAvailable"
            value={itemAvailable}
            onChange={(e) => setItemAvailable(e.target.value)}
            label="Dostępne?"
            error={emptyFields && emptyFields.includes("itemAvailable")}
          >
            <MenuItem value="">
              <em>Dostępne?</em>
            </MenuItem>
            {itemAvailableOptions.map((option) => (
              <MenuItem key={option} value={option}>
                {option}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
        <CenteredDiv>{loading ? <CircularProgress /> : null}</CenteredDiv>
        {error && <ErrorBox error={error} color={"error"} />}
        <Button
          variant="contained"
          type="submit"
          sx={{
            color: theme.palette.common.white,
            backgroundColor: theme.palette.primary.main,
            ":hover": { bgcolor: theme.palette.secondary.main},
            marginTop: "1rem",
          }}
        >
          Dodaj
        </Button>
        </>
      )}
    </Box>
  );
};

export default ItemConfigForm;